
import React from "react";
import { Star, Crown, Gem } from "lucide-react";
import { cn } from "@/lib/utils";
import { getRpgPipClasses } from "./progressPipUtils";

interface RpgProgressPipProps {
  index: number;
  pipValue: number;
  isActive: boolean;
  isHovered: boolean;
  pipSizeClass: string;
  iconSizeClass: string;
  darkMode: boolean;
  readonly: boolean;
  onPipClick?: (pipValue: number) => Promise<boolean>;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  onClick: () => void;
}

const RpgProgressPip: React.FC<RpgProgressPipProps> = ({
  index,
  pipValue,
  isActive,
  isHovered,
  pipSizeClass,
  iconSizeClass,
  darkMode,
  readonly,
  onPipClick,
  onMouseEnter,
  onMouseLeave,
  onClick
}) => {
  const getPipIcon = (index: number) => {
    const icons = [Star, Crown, Gem];
    const IconComponent = icons[index % icons.length];
    return <IconComponent className={iconSizeClass} />;
  };

  return (
    <div 
      className={getRpgPipClasses(pipSizeClass, isActive, isHovered, darkMode, readonly, onPipClick)}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      role={!readonly && onPipClick ? "button" : undefined}
      tabIndex={!readonly && onPipClick ? 0 : undefined}
      aria-label={!readonly && onPipClick ? `Set progress to ${pipValue}` : undefined}
    >
      {/* Content */}
      <div className="relative z-10 flex items-center justify-center">
        {isActive ? (
          getPipIcon(index)
        ) : (
          <div className={cn(
            "rounded-full border-2 border-current opacity-50",
            iconSizeClass
          )} />
        )}
      </div>

      {/* Gentle hover overlay */}
      {!readonly && isHovered && (
        <div className="absolute inset-0 transition-opacity duration-300 rounded-inherit bg-amber-300/20" />
      )}
    </div>
  );
};

export default RpgProgressPip;
